<div
  class="popup-menu-content {{ theme }}"
  #contentEl
  (click)="menuClicked()"
  [attr.data-testid]="testId"
>
  <div class="scrollable-content">
    <ng-content></ng-content>
  </div>
</div>
